import { ROUTE_PATH_ADMIN } from '../../configRoutes';

export const ROUTE_PATH_SUPER_SEARCH = ROUTE_PATH_ADMIN + '/search';
